import { useCallback } from 'react';

import useBoolean from '../../hooks/use-boolean';

export const useClosableAlert = (onClose?: () => void) => {
  const { value: isClosed, toggle: close } = useBoolean(false);

  const onPress = useCallback(() => {
    onClose?.();
    close();
  }, [close, onClose]);

  return { isClosed, onPress };
};
